export const table_titles = [
	{ name: "#", size: 10, order: "" },
	{ name: "Nombre", size: 20, order: "name" },
	{ name: "Aplicaciones", size: 10, order: "" },
	{ name: "Categoría", size: 10, order: "" },
	{ name: "Estado", size: 5, order: "" },
	{ name: "País", size: 10, order: "" },
	{ name: "Acción", size: 10, order: "" },
];

export const base_list = {
	page: 1,
	paginate: 10,
	order: "name",
	orderType: "desc",
};

export const base_element = {
	id: "",
	name: "",
	country_id: "",
	category_id: "",
	zpl_printer_configured: false,
	use_code_oa: false,
	use_sectors: true,
	tools: [],
};

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999999,
	}),
	menu: (provided) => ({ ...provided, zIndex: 9999999 }),
};
